import type { ReactElement } from 'react'
import React from 'react'

interface GlobalActionsProps {
  children: ReactElement | ReactElement[]
}

function GlobalActions({ children }: GlobalActionsProps): JSX.Element {
  return <div className="flex items-center space-x-2">{children}</div>
}

export default GlobalActions
